import API from './base';

class AnnoncesSearchResultApi extends API {
  getAnnonces = ({
    latitude, longitude, category, limit, page,
  }) => {
    const annoncesQueryParams = new URLSearchParams({
      latitude,
      longitude,
      category,
      limit: `${limit ?? 3}`,
      page: `${page ?? 1}`,
    });

    return this.get('/api/web/v1/announces', annoncesQueryParams);
  };
}

export default new AnnoncesSearchResultApi();
